import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Button, Form } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import SepomexCodigoPostalSuggestions from '../../../../catalogs/SepomexCodigoPostalSuggestions';

class ReceptorNacionalFiscalInfoForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    const data = props.data || {};

    this.state = {
      data: data,
      validator: new Validator(data, this.rules)
    };
  }

  get rules() {
    return {
      NomDenRazSocR: ['required', 'string', 'min:1', 'max:254'],
      RfcR: ['required', 'string', 'min:12', 'max:13', 'regex:/^[A-Z,Ñ,&]{3,4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z,0-9][A-Z,0-9][0-9,A-Z]$/'],
      Email: ['email', 'min:3', 'max:40'],
      CurpR: ['string', 'size:18', 'regex:/^([A-Z][AEIOUX][A-Z]{2}([0-9]{2})(0[1-9]|1[012])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM](AS|BC|BS|CC|CL|CM|CS|CH|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[A-Z]{3}[0-9A-Z][0-9])$/'],
      DomicilioFiscalR: ['required', 'string', 'regex:/^[0-9]{5}$/']
    }
  }

  componentDidMount() {
    if (!!this.props.data) {
      this.handleOnChange({});
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  handleOnAdd = () => {
    const { data } = this.state;

    this.props.onChange({
      NacionalidadR: 'Nacional',
      Nacional: {
        ...data
      }
    });
  }

  handleOnCancel = () => {
    this.props.onChange({});
  }

  handleOnSuggestionSelect = (name) => (item) => {
    const value = item ? item.clave : '';

    let values = {
      [name]: value
    };

    this.handleOnChange(values);
  }

  render() {
    const rules = this.rules;
    const { data, isValid } = this.state;

    return (
      <Form autoComplete="off">

        <FormControl type="text"
          label="RFC"
          name="RfcR"
          placeholder=""
          help=""
          casing={ 'upper' }
          minLength={ 12 }
          maxLength={ 13 }
          autoFocus={ true }
          rules={ rules.RfcR }
          value={ data.RfcR }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Razón social"
          name="NomDenRazSocR"
          placeholder=""
          help=""
          rules={ rules.NomDenRazSocR }
          value={ data.NomDenRazSocR }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="Email"
          name="Email"
          placeholder="email@example.com"
          help=""
          rules={ rules.Email }
          value={ data.Email }
          onChange={ this.handleOnChange }
        />

        <FormControl type="text"
          label="CURP"
          name="CurpR"
          help=""
          casing={ 'upper' }
          minLength={ 18 }
          maxLength={ 18 }
          rules={ rules.CurpR }
          value={ data.CurpR }
          onChange={ this.handleOnChange }
        />

        <SepomexCodigoPostalSuggestions
          name="DomicilioFiscalR"
          id="DomicilioFiscalR"
          label="Código postal domicilio fiscal "
          help=""
          rules={ rules.DomicilioFiscalR }
          value={ data.DomicilioFiscalR }
          onSelect={ this.handleOnSuggestionSelect('DomicilioFiscalR') }
        />

        <div>
          <Button variant="secondary"
            className="mt-3 mr-2"
            onClick={ this.handleOnCancel }
          >
            Cancelar
          </Button>

          <Button variant="primary"
            className="mt-3"
            disabled={ !isValid }
            onClick={ this.handleOnAdd }
          >
            Confirmar
          </Button>
        </div>

      </Form>
    )
  }
}

export default ReceptorNacionalFiscalInfoForm;